import { render, staticRenderFns } from "./GastroAnamnesiFisiologicaEdit.vue?vue&type=template&id=7e04d9c5"
import script from "./GastroAnamnesiFisiologicaEdit.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiFisiologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports